import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Spinner from './../Spinner';
import { fetchClaimUserDetails,raiseClaim, setNavigationData } from '../../store/reducers/claimReducer';
import { IncidentType } from '../../utils/Constants';
import { useLocation, useNavigate } from 'react-router-dom';
import LocationAndAddress from './LocationPrompt';
import { showAlert } from '../../store/reducers/alertReducer';

const RaiseClaim = () => {

 const dispatch = useDispatch();
 const location = useLocation();
 const navigate = useNavigate();
 const { id } = location.state || {};
 const subscriptionId = id;

  const [formData, setFormData] = useState({});
  const [errors, setErrors] = useState({});
  const [latitude, setLatitude] = useState(null);
  const [longitude, setLongitude] = useState(null);
  const [formDisabled, setFormDisabled] = useState(false);
  const [address, setAddress] = useState(null);
  const [focusedField, setFocusedField] = useState(null);
  const { response, loader, claimRaiseloading } = useSelector((state) => state.claimList);
  
  const userData = response.user ?? {};

console.log("responseresponseresponseresponseresponse",userData);

  useEffect(() => {
    dispatch(fetchClaimUserDetails(subscriptionId));
  }, [dispatch]);

  useEffect(() => {
    if (navigator.geolocation) {
        console.log("navigatornavigator",navigator.geolocation);
      navigator.geolocation.getCurrentPosition(
        (position) => {
          setLatitude(position.coords.latitude);
          setLongitude(position.coords.longitude);
        },
        (err) => {
            setErrors(err.message);
        }
      );
    } else {
        setErrors('Geolocation is not supported by your browser.');
    }
  }, []);

  useEffect(() => {
    if (userData && Object.keys(userData).length > 0) {
      setFormData({
        name: userData.name || '',
        reg_num: userData.reg_number || '',
        // chasis_number: userData.chassis_number || '',
        email: userData.email || '',
        mobile: userData.mobile_number || '',
        incident_type: ''
      });
      setFormDisabled(true); 
    }
  }, [userData]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value
    }));

    if (errors[name]) {
        setErrors((prev) => ({ ...prev, [name]: '' }));
      }
  };

  const toTitleCaseWithSpace = (str) => {
    return str
      .split('_')
      .map(word => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ');
  };

  const validate = () => {
    const requiredFields = [
      'incident_type','mobile'
    ];
  
    const newErrors = {};
    let firstInvalidField = null;
  
    requiredFields.forEach((field) => {
      
      if (!formData[field]) {
        const readableField = toTitleCaseWithSpace(field);
        newErrors[field] = `${readableField} is required`;
        if (!firstInvalidField) firstInvalidField = field;
      }
    });
  
    setErrors(newErrors);
  
    if (firstInvalidField) {
      const el = document.getElementsByName(firstInvalidField)[0];
      if (el) {
        el.focus();
        setFocusedField(firstInvalidField);
      }
    }

    return Object.keys(newErrors).length === 0;

  };

  const handleEnableLocation = () => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          setLatitude(position.coords.latitude);
          setLongitude(position.coords.longitude);
        },
        (error) => {
          alert('Location access denied or unavailable. Please enable location in your browser settings.');
        }
      );
    } else {
      alert('Geolocation is not supported by your browser.');
    }
  };
  
const handleSubmit = async() => {

    try{
        if (!validate()) return;

      setFormDisabled(true); // Disable form
       
        // const localFormData = {
        //   name: userData.name,
        //   email: userData.email,
        //   mobile: userData.mobile_number,
        //   reg_num: userData.reg_number,
        //   chassis_number: userData?.chassis_number ?? '',
        //   incident_type: formData?.incident_type ?? '',
        //   subscription_id: subscriptionId,
        //   latitude:latitude || 13.0225,
        //   longitude:longitude || 80.2032,
        //   address:address
        // };

        const localFormData = {
            name: formData.name || userData.name,
            email: formData.email || userData.email,
            mobile: formData.mobile || userData.mobile_number,
            reg_num: formData.reg_num || userData.reg_number,
            // chassis_number: formData.chasis_number || userData.chassis_number,
            incident_type: formData.incident_type || '',
            subscription_id: subscriptionId,
            latitude: latitude || 13.0225,
            longitude: longitude || 80.2032,
            address: address
          };

          
        console.log("RaiseClaimhandleSubmitlocalFormData",localFormData);
        dispatch(raiseClaim(localFormData))
        .unwrap()
        .then((response) => {
            console.log("dispatchresponse",response?.data?.AssistanceNo);
            const assistNo = response?.data?.AssistanceNo ?? '';
          if(response?.success){
            let userId = userData.id || '';
            dispatch(setNavigationData({ assistNo, userId }));
            navigate('/track-claim',{ state: { assistNo,userId } });
            dispatch(showAlert({ type: 'success', message: response?.message }));
          }else{
            dispatch(showAlert({ type: 'error', message: response?.message }));
          }
        });
      
    }catch (error) {
        console.error('Error during submission:', error);
        alert('Something went wrong. Please try again.');
        setFormDisabled(false); // Re-enable form on error
    } finally {
    }
  }
  console.log("latitude Raise claim",latitude);
  console.log("longitude Raise claim",longitude);
  return (
    <div className="raise-claim">
    <div className='profile-details'>

      <form className="customer-form" noValidate>
        <h3 className='info'>Customer Information</h3>
          <label>Customer Name</label> 
        <input 
          name="name" 
          value={formData.name || ''} 
          onChange={handleChange} 
          className={errors.first_name ? 'focusedColumn' : ''}

          />
        {errors.first_name && <span className="error-text">{errors.first_name}</span>}

        <label>Vehicle Registration Number</label> 
        <input 
           name="reg_num" 
           value={formData.reg_num || ''} 
           onChange={handleChange} 
           disabled={formDisabled}
           className={errors.reg_num ? 'focusedColumn' : ''}
        />
        
        {errors.reg_num && <span className="error-text">{errors.reg_num}</span>}

        {/* <label>Vehicle Chasis Number</label> 
        <input 
          name="chasis_number" 
          value={formData.chasis_number || ''} 
          onChange={handleChange} 
          disabled={formDisabled}
          className={errors.pincode ? 'focusedColumn' : ''}
        />
        {errors.chasis_number && <span className="error-text">{errors.chasis_number}</span>} */}

        <label>Email ID</label> 
        <input 
          name="email" 
          value={formData.email || ''} 
          onChange={handleChange} 
          disabled={formDisabled}
        />
        {errors.email && <span className="error-text">{errors.email}</span>}

        <label>Mobile Number</label> 
        <input 
          name="mobile" 
          value={formData.mobile || ''} 
          onChange={handleChange} 
          required
          onPaste={(e) => {
            const pasted = e.clipboardData.getData('Text');
            if (!/^[1-9][0-9]{0,9}$/.test(pasted)) {
              e.preventDefault();
            }
          }}
          className={errors.mobile ? 'focusedColumn' : ''}
        />
        {errors.mobile && <span className="error-text">{errors.mobile}</span>}
        {loader && <Spinner />}

        <label>Incident Type</label> 
        <select 
           name="incident_type" 
           value={formData?.incident_type || ''} 
           onChange={handleChange} 
           required
           className={errors.incident_type ? 'focusedColumn' : ''}
        >
          <option value=""> Incident Type*</option>
          {IncidentType.map((type, index) => (
                <option key={index} value={type.value}>
                {type.label}
                </option>
            ))};
        </select>
        {errors.incident_type && <span className="error-text">{errors.incident_type}</span>}

        {(!latitude || !longitude) && (
            <LocationAndAddress 
                address={address} 
                setAddress={setAddress}
                setLatitude={setLatitude}
                setLongitude={setLongitude}
            />
       )}

        {claimRaiseloading ? (
                <Spinner />
                ) : (
                <button
                    type="button"
                    disabled={!latitude}
                    // className={!latitude}"save-continue"
                    className={`save-continue ${!latitude ? 'save-continue-diabled' : ''}`}
                    onClick={handleSubmit}
                >
                    Continue
                    <img 
                    src={`${process.env.PUBLIC_URL}/assets/proceed_arrow.svg`} 
                    alt="Save" 
                    className="proceed-arrow" 
                    />
                </button>
        )}
      </form>
    </div>
    </div>
  );
};

export default RaiseClaim;
